import { Box } from '@primer/react';
import { BetterSystemStyleObject } from '@primer/react/lib/sx';
import React from 'react';
interface IBlockProps {
    children: React.ReactNode,
    sx?: BetterSystemStyleObject
}
const Block = (props: IBlockProps) => {
    return (
        <Box sx={{
            backgroundColor: "#fff",
            p: 3,
            pt: 3,
            borderRadius: 2,
            // mb: 2,
            // ml: 2,
            ...props.sx,
        }}
            className='liquid-glass'
        >
            {props.children}
        </Box>
    );
};

export default Block;